<script>
    export default {
        props: {
            providerID: Number
        },
        computed: {
            provider() {return this.$store.getters.PROVIDER_BY_ID(this.providerID)},
        },
        emits: ["calldelete"],
    }
</script>

<template>
    <input 
        disabled
        :value="provider['name']"
        class="right_input"
    >
    <button
        @click="$emit('calldelete', provider['id'])"
        class="button_blue_100 ml_10"
    >Delete</button>
</template>